import http from "../tools/http";

export default {
  getAll(orgUUID) {
    return http.get(`/organizations/${orgUUID}/ips`);
  },
  create(orgUUID, data) {
    return http.post(`/organizations/${orgUUID}/ips`, data);
  },
  delete(orgUUID, uuid) {
    return http.delete(`/organizations/${orgUUID}/ips/${uuid}`);
  },
  reset(orgUUID) {
    return http.patch(`/support/reset-ip/${orgUUID}`);
  }
};
